<section class="healthcare-intro section-padding">
    <div class="container">
        <div class="row align-items-center g-5">

            <div class="col-lg-6">
                <div class="healthcare-intro-content">

                    <span class="section-badge">
                        {{ 'healthcareIntro.eyebrow' | translate }}
                    </span>

                    <h2 class="section-title">
                        {{ 'healthcareIntro.title' | translate }}
                    </h2>

                    <p class="section-subtitle">
                        {{ 'healthcareIntro.subtitle' | translate }}
                    </p>

                    <div class="healthcare-benefits">

                        <div class="healthcare-benefit">
                            <i class="fas fa-calendar-check" aria-hidden="true"></i>
                            <div>
                                <h3>
                                    {{ 'healthcareIntro.benefit1Title' | translate }}
                                </h3>
                                <p>
                                    {{ 'healthcareIntro.benefit1Text' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="healthcare-benefit">
                            <i class="fas fa-hospital" aria-hidden="true"></i>
                            <div>
                                <h3>
                                    {{ 'healthcareIntro.benefit2Title' | translate }}
                                </h3>
                                <p>
                                    {{ 'healthcareIntro.benefit2Text' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="healthcare-benefit">
                            <i class="fas fa-user-nurse" aria-hidden="true"></i>
                            <div>
                                <h3>
                                    {{ 'healthcareIntro.benefit3Title' | translate }}
                                </h3>
                                <p>
                                    {{ 'healthcareIntro.benefit3Text' | translate }}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="healthcare-image">
                    <img src="assets/images/healthcare-scheduling.png"
                        alt="Healthcare team coordinating patient appointments and hospital resources" loading="lazy"
                        width="1536" height="1024" />
                </div>
            </div>

        </div>
    </div>
</section>